import lget from 'lodash/get';

import { useMemo } from 'react';

import { useCarrierContractSchemaQuery } from './queries';

interface UseUISchemaReturnType {
  defaultValue: string | number | boolean | undefined;
  widget: string | undefined;
  isOptional: boolean;
  isReadonly: boolean;
}

interface UseUISchemaArgs {
  schemaId: string;
  path: string;
}

export function useUISchema({ path, schemaId }: UseUISchemaArgs): UseUISchemaReturnType {
  const { data } = useCarrierContractSchemaQuery(schemaId);

  const entry = useMemo(() => {
    if (path.startsWith('step_')) {
      return lget(data?.authentication_form_ui_schema, path);
    }

    return lget(data?.ui_schema, path.replace('carrier_configuration_data.', ''));
  }, [data, path]);

  return {
    defaultValue: entry?.default_value,
    isReadonly: !!entry?.readonly,
    isOptional: !!entry?.optional,
    widget: entry?.widget,
  };
}
